import { render, staticRenderFns } from "./homepage1.vue?vue&type=template&id=4f72a72e&scoped=true&"
import script from "./homepage1.vue?vue&type=script&lang=js&"
export * from "./homepage1.vue?vue&type=script&lang=js&"
import style0 from "./homepage1.vue?vue&type=style&index=0&id=4f72a72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72a72e",
  null
  
)

export default component.exports